import { EventItemPaymentMethod } from './event-item-payment-method.model';
import { PaymentMethodTaxItem } from './payment-method-tax-item.model';
export class EventPaymentMethod {
  public constructor() {
    this.EventId = 0;
    this.ItemNum = 0;
    this.PaymentMethodId = 0;
    this.PaymentMethodDescr = '';
    this.Descr = '';
    this.Fee = 0;
    this.FeeType = 0;
    this.FeeDescr = '';
    this.Accept = false;
    this.EventItemPaymentMethods = new Array<EventItemPaymentMethod>();
    this.TaxItems = new Array<PaymentMethodTaxItem>();
  }

  public EventPaymentMethodId: number;
  public EventId: number;
  public ItemNum: number;
  public PaymentMethodId: number;
  public PaymentMethodDescr: string;

  public Descr: string;
  public Fee: number;
  public FeeType: number;
  public FeeDescr: string;
  public Accept: boolean;

  public EventItemPaymentMethods: Array<EventItemPaymentMethod>;
  public TaxItems: Array<PaymentMethodTaxItem>;
}
